const optionsHelper = {
    handleTimesAndOptions(state, optiondtoList) {
        let array = [];
        optiondtoList.forEach(item => {
            array.push(item);
            const option = item.optionid;

            if (state.user.config.parameters.parameters.timesandoptionsdescriptions) {
                const optionsString = state.user.config.parameters.parameters.timesandoptionsdescriptions;
                for (var optionCount = 0; optionCount < optionsString.split('¤').length; optionCount++) {
                    var optionItem = optionsString.split('¤')[optionCount].split('|');
                    var optionItemId = optionItem[0].split('^')[1];
                    var optionItemTitle = optionItem[1].split('^')[1];
                    var optionItemDescription = optionItem[2].split('^')[1];
                    if (option === optionItemId) {
                        item.optiondisplayname = optionItemTitle;
                        item.optiondescription = optionItemDescription;
                    }
                }
            }

            if (option === '1000') {
                state.user.lists.timesArrivalManual = item.dropofftimes;
            }
            if (option === '1001') {
                state.user.lists.timesArrivalManualRental = item.dropofftimes;
            }
            if (option === '1002') {
                state.user.lists.timesArrivalManualWaiting = item.dropofftimes;
            }
            if (option === '1100') {
                state.user.lists.timesArrivalManualRentLog = item.dropofftimes;
            }
        });
        return array;
    }
};

export default optionsHelper;
